import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { memo } from 'react'
import { URL_MFC_SHARE } from '../../constants/urls'
import { palette } from '../styles/colors'

const imageStyles = css({
    background: 'transparent',
    filter: palette.imagesMonochromeFilter,
})

const StyledAnchor = styled('a')({
    justifyContent: 'center',
    flexDirection: 'column',
    textDecoration: 'none',
    alignItems: 'center',
    display: 'flex',
    color: '#999',
    '& p': {
        fontSize: 11,
        margin: 0,
        lineHeight: 1,
    },
})

interface IShareProps {
    width?: number
    albums?: number
    recordings?: number
    slug?: string
}

const Share = (props: IShareProps) => {
    const { width = 120, albums, recordings, slug } = props

    const albumsText = `${albums} Album${albums > 1 ? 's' : ''}`
    const recordingsText = `${recordings} Recording${recordings > 1 ? 's' : ''}`

    const styles = {
        ...(albums > 0 || recordings > 0 ? { padding: 5 } : {}),
        width,
    }

    return (
        <StyledAnchor
            href={`${URL_MFC_SHARE}/${slug}`}
            rel="noopener noreferrer"
            target="_blank"
            data-testid="Link__ShareLogo"
        >
            <img
                src="https://img.mfcimg.com/files/images/misc/MFCShare.svg"
                css={imageStyles}
                style={styles}
            />
            {albums > 0 && <p>{albumsText}</p>}
            {recordings > 0 && <p>{recordingsText}</p>}
        </StyledAnchor>
    )
}

export default memo(Share)
